module.exports = __webpack_public_path__ + "static/img/d-5.0730d0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/d-5.png
// module id = Whip
// module chunks = 0